module.exports = __webpack_public_path__ + "static/media/jsIcon.320cb931.svg";